import SvgIcon from "./IconEye.svg?react";
const IconEye = SvgIcon;
export default IconEye;
